import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';

export const getAuthUserIsDontShowShareHint = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    if (!user.meta) return false;

    return user.meta.isDontShowShareHint;
};
